export default __webpack_public_path__ + "static/media/FiraSans-Bold.e7a4433a.woff";